import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import MatrizMobile from './MatrizMobile';
import MatrizDesktop from './MatrizDesktop';

function Matriz({ app, config }) {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    return isMobile ? <MatrizMobile app={app} config={config} />
        : <MatrizDesktop app={app} config={config} />;
}

Matriz.defaultProps = {
    app: null,
    config: {}
};

Matriz.propTypes = {
    app: PropTypes.object,
    config: PropTypes.object
};

export default Matriz;
